import { AR_QUALIFICATION_CHECK_TEXT } from '../../../lang';
import type { LanguageQualification as ApplicationLanguageQualificationType } from '../../../../Application/graphql';
import { formatDateString } from '../../../../../utils';
import {
  type BlockDataItem,
  BlockDataValueType,
} from '../../../../../components';
import { getOptionsLabelClear } from '../../../../Monitor/components';
import {
  languageQualificationTestTypeOptions,
  LANGUAGE_QUALIFICATION_TEST_TYPE,
} from '../../../../Application/components';
import { PAGE_TEXT } from '../../../../Application/components/ApplicationForm/lang';

const ENGLISH_TEXT = PAGE_TEXT.QUALIFICATION.LANGUAGE_QUALIFICATION;

export const getLanguageQualificationMap = (
  languageQualification: ApplicationLanguageQualificationType,
): BlockDataItem[] => {
  const {
    needEnglishTest = true,
    resultAnnouncedIndicator = false,
    testType,
    testDate,
    expectedResultUpdateDate,
    result,
    referenceNo,
    supportingDocuments,
  } = languageQualification ?? {};

  const { listening, reading, writing, speaking, overall, resultReceiptDate } =
    result ?? {};

  const languageMap: BlockDataItem[] = [
    {
      label: ENGLISH_TEXT.NEED_ENGLISH_TEST,
      value: needEnglishTest ? 'Yes' : 'No',
    },
    ...(needEnglishTest
      ? [
          ...(resultAnnouncedIndicator
            ? [
                {
                  label: ENGLISH_TEXT.TEST_TYPE,
                  value: getOptionsLabelClear(
                    languageQualificationTestTypeOptions,
                    testType as LANGUAGE_QUALIFICATION_TEST_TYPE,
                  ) as BlockDataItem['value'],
                },
                {
                  label: ENGLISH_TEXT.TEST_DATE,
                  value: formatDateString(testDate),
                },
                {
                  label: ENGLISH_TEXT.RESULT_RECEIPT_DATE,
                  value: formatDateString(resultReceiptDate),
                },

                {
                  label: ENGLISH_TEXT.LISTENING,
                  value: listening,
                },
                {
                  label: ENGLISH_TEXT.READING,
                  value: reading,
                },
                {
                  label: ENGLISH_TEXT.WRITING,
                  value: writing,
                },
                {
                  label: ENGLISH_TEXT.SPEAKING,
                  value: speaking,
                },
                {
                  label: ENGLISH_TEXT.OVERALL_BAND_SCORE,
                  value: overall,
                },
                {
                  label:
                    testType === LANGUAGE_QUALIFICATION_TEST_TYPE.IELTS
                      ? ENGLISH_TEXT.TEST_REPORT_FORM_NO
                      : ENGLISH_TEXT.APPOINTMENT_NO,
                  value: referenceNo,
                },
                {
                  label: ENGLISH_TEXT.CERTIFICATE,
                  value: supportingDocuments,
                  valueType: BlockDataValueType.FILE_ARRAY,
                },
              ]
            : [
                {
                  label: ENGLISH_TEXT.EXPECTED_UPDATE_DATE,
                  value: formatDateString(expectedResultUpdateDate),
                  defaultValue: AR_QUALIFICATION_CHECK_TEXT.NA,
                },
              ]),
        ]
      : []),
  ];
  return languageMap;
};
